async function confirmUserRegistration(_optinToken: string) {
  throw new Error('Functionality not implemented');
}

export { confirmUserRegistration };
